import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { APIService, KPI } from '../api';

@Injectable({
  providedIn: 'root'
})
export class RefrigerantTypeService {

  constructor(
    private apiService: APIService,
  ) { }

  public _refrigerantFluidHasChanged$: BehaviorSubject<void> = new BehaviorSubject<void>(undefined);
  public refrigerantFluidHasChanged(): void {
    this._refrigerantFluidHasChanged$.next();
  }


  public _refrigerantTypes: Observable<KPI.RefrigerantType[]>;
  public get refrigerantTypes$(): Observable<KPI.RefrigerantType[]> {
    if (!this._refrigerantTypes) {
      this._refrigerantTypes = this.apiService.get_refrigerant_types();
    }
    return this._refrigerantTypes;
  }
}
